var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._l(12, function (i) {
      return _c(
        "v-list",
        { key: i, staticClass: "pt-2 pb-1" },
        [
          _c("v-skeleton-loader", {
            attrs: { type: "list-item-avatar-two-line" },
          }),
          _c("v-divider"),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }